<script setup lang="ts">
import { computed } from 'vue';
import { every, isEmpty } from 'lodash';
import Button from 'primevue/button';
import { useComponentComposable } from '@/components/useComponentComposable';
import LongParagraphModal from '../modal/utils/LongParagraphModal.vue';
import ShowImageByScreen from '@/components/ShowImageByScreen.vue';

interface Props {
  value: any;
}
const props = defineProps<Props>();

const { renderHTMLContent } = useComponentComposable();

const detailInfo = computed(() => {
  return props.value;
});

const isEmptyDetail = computed(() => {
  return every(props.value, isEmpty);
});
const openHref = (link: string) => {
  window.open(link, 'blank');
};
</script>
<template>
  <div class="flex w-full gap-3 surface-section border-round surface-promo-content" v-if="!isEmptyDetail">
    <div class="p-0 md:text-left flex" :class="detailInfo.image ? 'w-6' : 'w-full'">
      <div class="flex flex-col justify-content-between">
        <div>
          <renderHTMLContent class="mb-3" :data="detailInfo.name" htmlElement="h2"></renderHTMLContent>
          <renderHTMLContent class="text-lg font-semibold mb-3" :data="detailInfo.subTitle"></renderHTMLContent>
          <LongParagraphModal class-component="break-word" :text="detailInfo.description" :maxCharacters="1000" />
        </div>
        <div class="mt-5 mb-3">
          <Button v-if="detailInfo.nameFirstButton" :label="detailInfo.nameFirstButton" type="button" class="vacv-btn mr-3" @click="openHref(detailInfo.urlFirstButton)"></Button>
          <Button v-if="detailInfo.nameSecondButton" :label="detailInfo.nameSecondButton" type="button" class="vacv-btn vacv-btn-secondary" @click="openHref(detailInfo.urlSecondButton)"></Button>
        </div>
      </div>
    </div>

    <ShowImageByScreen alt="image-render" class="image md:ml-auto block md:h-full" :images="detailInfo.renderImage"></ShowImageByScreen>
  </div>
</template>
<style lang="scss" scoped>
.surface-promo-content {
  flex-direction: column-reverse;
}
.image {
  clip-path: none;
  width: 100%;
  max-height: 250px;
  object-fit: cover;
  border-radius: 6px;
}
@media screen and (min-width: 768px) {
  .surface-promo-content {
    flex-direction: row;
  }
  .image {
    clip-path: polygon(8% 0, 100% 0%, 100% 100%, 0 100%);
    width: 50%;
    border-radius: 0 6px 6px 0;
  }
}
</style>
